<template>
	<div
		class="svg-icon"
		:class="[flexClass]">
		<nuxt-icon
			:filled="true"
			v-bind="$attrs"
			:name="name" />
	</div>
</template>
<script setup lang="ts">
const props = defineProps<{
	height?: number | string
	width?: number | string
	name: string
	color?: string
	default?: boolean
	flex?: boolean
}>()

const heightPx = computed(() => (props.height === 'fit-content' ? props.height : `${props.height}px`))

const widthPx = computed(() => {
	if (!props.width) return `${props.height}px`
	return typeof props.width === 'string' ? props.width : `${props.width}px`
})

const verticalAlign = computed(() => (props.default ? 'unset' : 'middle'))
const marginBottom = computed(() => (props.default ? '0px' : '0.125em'))

const flexClass = computed(() => (props.flex ? 'flex' : ''))
</script>
<style lang="scss">
.svg-icon {
	width: v-bind(widthPx);
	min-width: v-bind(widthPx);
	height: v-bind(heightPx);
	color: v-bind(color);
	font-size: v-bind(heightPx);

	&.flex {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.nuxt-icon svg {
		height: 100%;
		width: 100%;
		vertical-align: v-bind(verticalAlign);
		margin-bottom: v-bind(marginBottom);
	}
}
</style>
